import type { Facility } from './facility';
import type { Company } from './company';
import type { Organization } from './organization';
import type { Permissions } from './permissions';

export enum UserRoles {
  SUPPLY_CHAIN_USER = "SUPPLY_CHAIN_USER",
  SUPPLY_CHAIN_ADMIN = "SUPPLY_CHAIN_ADMIN",
  CARBON_ACCOUNTING_USER = "CARBON_ACCOUNTING_USER",
  CARBON_ACCOUNTING_ADMIN = "CARBON_ACCOUNTING_ADMIN",
  CARBON_ACCOUNTING_READ_ONLY = "CARBON_ACCOUNTING_READ_ONLY",
  PARTNER_USER = "PARTNER_USER", 
  PARTNER_ADMIN = "PARTNER_ADMIN",
  PARTNER_READ_ONLY = "PARTNER_READ_ONLY",
  BONO_ACCOUNT_MANAGER = "BONO_ACCOUNT_MANAGER",
  BONO_SUPER_ADMIN = "BONO_SUPER_ADMIN"
}

export interface Title {
  id: string;
  titleName: string;
}

export interface Policy {
  id: string;
  accepted: boolean;
  explanation: string;
  fileUrl: string;
  policyName: string;
  policyOrder: number;
  systemPolicy: boolean;
}

export interface ROLE {
  id: string;
  roleName: UserRoles;
  // In the feature, a permission list may come from the backend.
  permissions?: Permissions[];
}

export interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  passwordSet: boolean;
  roles: ROLE[];
  userTitle: Title;
  userAssignedFacilities?: Facility[];
  dataPolicies?: Policy[];
  assignedCompanies: Company[];
  cognitoSub?: string;
  organization?: Organization;
  locale: string
}

export interface ProcessedUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: ROLE[];
  companyId: string | null;
  organization?: Organization;
  userTitle?: Title;
  [key: string]: any;
}
